import React from "react";
import { readCookie } from "../../utils/helpers";
import { userStore } from "../../utils/signals";
import { useSignals } from "@preact/signals-react/runtime";

const Home = () => {
  useSignals();
  return (
    <div>
      You're logged in with {userStore.value.email} to the upcoming micro service, clear cache/cookies to sign up again
    </div>
  );
};

export default Home;
